<template>
  <block-item-card
    :min-height="minBlockHeight"
    :title="$t('RiskLiquidity.Section.LiquidityRiskAssessment.Title')"
    :tooltip="$t('RiskLiquidity.Section.LiquidityRiskAssessment.Tooltip')"
    style="position:relative!important;"
  >
    <v-row
      class="ma-0 px-2"
      no-gutters
    >
      <v-col
        class="ma-0 pa-2"
        cols="12"
        md="6"
      >
        <liquidity-risk-assessment-card
          :item="currentItem"
          :title="currentAccountCompany"
          :logo-url="currentAccountCompanyLogoUrl"
        />
      </v-col>
      <v-col
        class="ma-0 pa-2"
        cols="12"
        md="6"
      >
        <liquidity-risk-assessment-card
          :item="bankSectorItem"
          :title="$t('RiskLiquidity.Section.LiquidityRiskAssessment.BankSector')"
        />
      </v-col>
    </v-row>
    <div
      class="d-flex align-center synthesis-text text-size-14"
      style="gap:20px; position:absolute; top:12px; right:20px;"
    >
      <div
        v-for="category in categories"
        :key="category"
        class="d-flex align-baseline"
        style="gap:8px;"
      >
        <div :class="`legend-icon ${category.toLowerCase()}-risk`" />
        <span class="text-size-14 synthesis-ui-grey-01--text ">{{ category }}</span>
      </div>
    </div>
  </block-item-card>
</template>

    <script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import LiquidityRiskAssessmentCard from './LiquidityRiskAssessmentCard.vue'

export default {
  name      : 'LiquidityRiskAssessment',
  components: {
    BlockItemCard,
    LiquidityRiskAssessmentCard

  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    MonitoringLiquidity: 'RiskLiquidity.MonitoringLiquidity.Data'
  },
  data () {
    return {
      minBlockHeight: 292

    }
  },
  computed: {
    monitoringLiquidity () {
      return this.MonitoringLiquidity || {}
    },
    liquidityRiskAssessment () {
      return this.monitoringLiquidity.liquidityRiskAssessment ?? {}
    },
    categories () {
      return this.liquidityRiskAssessment.categories
    },
    currentItem () {
      return this.liquidityRiskAssessment.currentItem ?? {}
    },
    bankSectorItem () {
      return this.liquidityRiskAssessment.bankSectorItem ?? {}
    },
    currentAccountCompany () {
      return this.user.selectedAccountCompany.shortName
    },
    currentAccountCompanyLogoUrl () {
      return this.user.selectedAccountCompany.logoUrl
    }

  }

}
</script>

<style scoped>
.legend-icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-icon.low-risk {
  background-color: var(--v-synthesis-ui-green-02-base);
}

.legend-icon.medium-risk {
  background-color: var(--v-synthesis-ui-yellow-01-base);
}

.legend-icon.high-risk {
  background-color: var(--v-synthesis-ui-orange-01-base);
}
</style>
